"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Remote = void 0;
var __1 = require("../..");
var helpers_1 = require("../../../helpers");
var utils_1 = require("../../../utils");
function Remote(_a) {
    var __deps__ = _a.__deps__, props = __rest(_a, ["__deps__"]);
    return !!__deps__ ? ReactRemoteFactory(__deps__)(props) : "";
}
exports.Remote = Remote;
var ReactRemoteFactory = function (_a) {
    var useState = _a.useState, useEffect = _a.useEffect, useRef = _a.useRef, createElement = _a.createElement;
    return function (props) {
        var id = props.id, __mfeName__ = props.__mfeName__, _a = props.attributes, attributes = _a === void 0 ? {} : _a;
        var ref = useRef();
        var _b = useState(true), isMounting = _b[0], setIsMounting = _b[1];
        var _c = useState(null), remote = _c[0], setRemote = _c[1];
        var serverSideHtml = useState((0, utils_1.generateServerSideHtmlFrom)(props))[0];
        useEffect(function () {
            __1.CommonMFE.importMFEFactory(props)(__mfeName__)
                .then(function (newRemote) {
                if (!newRemote ||
                    !("__mfeName__" in newRemote) ||
                    newRemote.__mfeName__ !== __mfeName__) {
                    throw new Error("Remote is undefined!");
                }
                setRemote(newRemote);
                return newRemote;
            })
                .catch(function (err) {
                var errorMessage = "[CSR ERROR] ".concat(err);
                setRemote(null);
                helpers_1.ConsoleHelper.error(errorMessage);
                return null;
            });
            return function () {
                if (remote && typeof remote.clientSideUnmount === "function") {
                    remote.clientSideUnmount(ref.current, props);
                    helpers_1.ConsoleHelper.log(id, "is destroyed...");
                }
            };
        }, []);
        useEffect(function () {
            if (remote) {
                if (isMounting) {
                    helpers_1.ConsoleHelper.log(id, "is mounting...");
                }
                else {
                    helpers_1.ConsoleHelper.log(id, " is updating...");
                }
                remote
                    .clientSideMount(ref.current, props, {
                    isMounting: isMounting,
                })
                    .then(function () {
                    if (isMounting) {
                        helpers_1.ConsoleHelper.log(id, "is mounted");
                        setIsMounting(false);
                    }
                    else {
                        helpers_1.ConsoleHelper.log(id, " is updated");
                    }
                });
            }
            return function () {
                // do nothing.
            };
        }, __spreadArray([remote], Object.values(props), true));
        var styles = "style" in attributes ? attributes.style : {};
        var _d = __1.MFE_SETTINGS[__mfeName__], type = _d.type, portlet = _d.portlet;
        var divObject = __assign(__assign({}, attributes), { "data-mfe-type": type, "data-mfe-name": __mfeName__, "data-mfe-portlet-src": (portlet === null || portlet === void 0 ? void 0 : portlet.path) || "", "data-mfe-portlet-unique-name": (portlet === null || portlet === void 0 ? void 0 : portlet.uniqueName) || "", "data-mfe-portlet-title": (portlet === null || portlet === void 0 ? void 0 : portlet.title) || "", style: __assign({ height: "100%", width: "100%" }, styles), ref: ref });
        if (!props.noServerSideHtml) {
            divObject['dangerouslySetInnerHTML'] = {
                __html: serverSideHtml,
            };
        }
        return createElement("div", divObject);
    };
};
